import React, { useState, useEffect } from "react";
import axios from "axios";
import { TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import localize from "../../../common/localize";
import useGlobalContext from "../../../hooks/useGlobalContext";
import {
  getInputProps,
  getInputLabelProps,
  PopperFullWidth,
} from "../../../common/appStyles";
import Combobox from "../../../components/common/Combobox";

export default function AddVehicle() {
  const {
    vehicleModel,
    setVehicleModel,
    PERSONAL_API,
    VEHICLE_TYPE_ENDPOINT,
    config,
  } = useGlobalContext();
  const [vehicleTypeData, setVehicleTypeData] = useState(null);
  const [personalData, setPersonalData] = useState(null);

  const getPersonal = async () => {
    const requestConfig = {
      ...config,
    };
    requestConfig.headers.pagination = -1;
    const data = await axios.get(`${PERSONAL_API}/`, requestConfig);

    setPersonalData(data?.data);
  };

  const getVehicleTypes = async () => {
    const requestConfig = {
      ...config,
    };
    requestConfig.headers.pagination = -1;
    const data = await axios.get(`${VEHICLE_TYPE_ENDPOINT}/`, requestConfig);

    setVehicleTypeData(data?.data);
  };

  useEffect(() => {
    getPersonal();
    getVehicleTypes();
  }, []);

  const handleChange = (e) => {
    setVehicleModel({
      ...vehicleModel,
      [e.target.name]: e.target.value,
    });
  };

  const handleVehicleTypeChange = (selectedVehicleType) => {
    if (selectedVehicleType) {
      setVehicleModel({
        ...vehicleModel,
        VehicleType: selectedVehicleType,
        VehicleTypeId: selectedVehicleType?.Id ?? 0,
      });
    } else {
      setVehicleModel({
        ...vehicleModel,
        VehicleType: null,
        VehicleTypeId: 0,
      });
    }
  };

  const handlePersonalChange = (selectedPersonal) => {
    if (selectedPersonal) {
      setVehicleModel({
        ...vehicleModel,
        Personal: selectedPersonal,
        PersonalId: selectedPersonal?.id ?? 0,
      });
    } else {
      setVehicleModel({
        ...vehicleModel,
        Personal: null,
        PersonalId: 0,
      });
    }
  };

  const handleSoatChange = (selectedSoatDate) => {
    if (selectedSoatDate) {
      setVehicleModel({
        ...vehicleModel,
        Soat: selectedSoatDate,
      });
    }
  };

  const handleTechnicalReviewChange = (selectedSoatDate) => {
    if (selectedSoatDate) {
      setVehicleModel({
        ...vehicleModel,
        TechnicalReview: selectedSoatDate,
      });
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <form className="w-full mt-2">
        <div className="w-full mb-4">
          <Combobox
            isRequired
            id="VehicleTypeId"
            handleValueChange={handleVehicleTypeChange}
            fieldLabel={localize.vehicle_type}
            fieldOptions={vehicleTypeData?.Data ?? []}
            fieldValue={vehicleModel?.VehicleType}
          />
        </div>

        <div className="flex justify-between my-4">
          <TextField
            required
            InputLabelProps={getInputLabelProps()}
            inputProps={getInputProps()}
            size="small"
            fullWidth
            id="outlined-basic"
            name="Identification"
            label={localize.identification}
            variant="outlined"
            onChange={handleChange}
            value={vehicleModel?.Identification}
          />
          <div className="mx-2" />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={localize.soat}
              className="w-1/2"
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              PopperComponent={PopperFullWidth}
              value={vehicleModel?.Soat}
              onChange={handleSoatChange}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={localize.technomechanic_review}
            className="w-full"
            InputLabelProps={getInputLabelProps()}
            inputProps={getInputProps()}
            PopperComponent={PopperFullWidth}
            value={vehicleModel?.TechnicalReview}
            onChange={handleTechnicalReviewChange}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <div className="w-full my-4">
          <Combobox
            id="Personal"
            popperFullWidth={PopperFullWidth}
            handleValueChange={handlePersonalChange}
            fieldLabel={localize.assigned_to}
            fieldOptions={personalData?.Data ?? []}
            fieldValue={vehicleModel?.Personal}
            customOptionLabel={(option) =>
              `${option.Identification} - ${option.SurName} ${option.LastName}`
            }
          />
        </div>
      </form>
    </div>
  );
}
